import { getEffectivePlan } from "./utils";

export const FeatureAccess = {
  ROLE_BUILDER: "roleBuilder",
  STAFF_ATTENDANCE: "staffAttendance",
  BOOKING_TYPE_CREATE: "bookingTypeCreate",
  DOCUMENT_MANAGEMENT: "documentManagement",
  DIGITAL_SIGNATURES: "digitalSignatures",
  EFAX: "efax",
};

const PLAN_REQUIREMENTS = {
  [FeatureAccess.ROLE_BUILDER]: 3,
  [FeatureAccess.STAFF_ATTENDANCE]: 3,
  [FeatureAccess.BOOKING_TYPE_CREATE]: 2,
  [FeatureAccess.DOCUMENT_MANAGEMENT]: 2,
  [FeatureAccess.DIGITAL_SIGNATURES]: 3,
  [FeatureAccess.EFAX]: 3,
};

export const getFeaturePlanRequirement = (featureKey) =>
  Number(PLAN_REQUIREMENTS[featureKey] || 1);

export const getFeatureAccess = (providerUser, featureKey) => {
  const requiredPlanId = getFeaturePlanRequirement(featureKey);
  const effectivePlan = Number(getEffectivePlan(providerUser) || 0);
  const hasAccess = effectivePlan >= requiredPlanId;
  return {
    featureKey,
    requiredPlanId,
    effectivePlan,
    hasAccess,
  };
};
